import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import * as R from 'ramda'
import { Helmet } from 'react-helmet'

import { events } from '../constant/events'

import EventMaster from "../components/EventMaster"
import EventFooter from "../components/EventFooter"

export default function Event() {
    const history = useHistory()
    const { search } = useLocation()
    let eid = queryString.parse(search).eid

    const [event, setEvent] = useState(events.blank)

    useEffect(() => {
        if (!R.includes(eid, events.ids)) {
            history.replace("/pageNotFound")
        } else {
            setEvent(events[eid])
        }
    }, [eid])

    return (
        <div className="event-setting">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{event.title} - FitGames</title>
                <meta name='description' content={event.subTitle} />
                <meta property='og:title' content={`${event.title} - FitGames`} />
                <meta property='og:description' content={event.subTitle} />
            </Helmet>

            <div>
                <EventMaster event={event} />
            </div>

            <div>
                <EventFooter event={event} />
            </div>

        </div>
    )
}

